import { useState, useEffect } from 'react'

/**
 * 値の変更をデバウンスするカスタムフック
 * @param value - デバウンスする値
 * @param delay - デバウンス遅延時間（ミリ秒）
 * @returns デバウンスされた値
 *
 * @example
 * ```tsx
 * const debouncedSearchTerm = useDebounce(searchTerm, 300)
 * // searchTermが変更されても、300ms後に debouncedSearchTerm が更新される
 * ```
 */
export const useDebounce = <T>(value: T, delay: number): T => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [value, delay])

  return debouncedValue
}
